import React, {Component} from 'react';
import Feature from './components/Feature';
import Review from './components/Review';
import Screen from './components/Screen';
import Team from './components/Team';
import Header from './components/Header';
import Footer from '../Footer/Footer';
import Download from './components/Download';

class Home extends Component {
  render(){
    return(
      <div>
      <Header/>
      <Feature/>
      <Review/>
      <Download/>
      <Screen/>
      <Team/>
     
      </div>
    )
  }
}

export default Home;